import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import imgKamillaFialhoWeb from "shared/assets/images/kamilla-fialho-sem-texto.png";
import "explorer/pages/new-estagio-artista/campanhas-especiais/CampanhasEspeciais.scss";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import { useHistory } from "react-router-dom";
import { createNewCashAdvance } from "shared/service/StrmService";
import { useSelector } from "react-redux";
import { formatNoSignObject, signByCurrency } from "shared/helpers/BRLFormat";

interface ModalCampaignKFEligibleProps {
  open: boolean;
  onCancel: () => void;
}

const ModalCampaignKFEligible: React.FC<ModalCampaignKFEligibleProps> = (
  props
) => {
  const { open, onCancel } = props;
  const { t } = useTranslation();
  const { loggedUser } = useSelector((state: any) => state.users);
  const { userArtist } = useSelector((state: any) => state.artists);
  const history = useHistory();

  const acceptWithoutAdvance = () => {
    history.push("/distribua", {
      specialCampaign: SpecialCampaignEnum.KamillaFialho,
    });
  };

  const acceptWithAdvance = async () => {
    await createNewCashAdvance(
      loggedUser.id,
      SpecialCampaignEnum.KamillaFialho
    );
    history.push("/adiantamentos");
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onCancel}
      width={700}
      title={null}
      className="modal-campanha-especial"
    >
      <>
        {/* <div
          style={{
            backgroundImage: `
    linear-gradient(180deg, rgba(25, 25, 25, 0) 0%, #5A57FF 100%),
    url(${imgKamillaFialhoWeb})
  `,
            backgroundSize: "cover",
            borderRadius: "8px 8px 0 0",
            minHeight: 330,
            width: "100%",
            position: "absolute",
          }}
        /> */}
        <div
          style={{
            position: "relative",
            backgroundImage: `
    linear-gradient(180deg, rgba(25, 25, 25, 0) 0%, #5A57FF 100%),
    url(${imgKamillaFialhoWeb})
  `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="conteudo">
            <div style={{ background: "#0D0D0D", opacity: 0.7 }} />
            <div
              style={{
                paddingTop: 112,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "0 48px",
              }}
            >
              <span className="chamada">
                {t("pages.CampanhasEspeciais.KamillaFialho.bemVindo")}
              </span>
              <h1 className="titulo">
                {t("pages.CampanhasEspeciais.KamillaFialho.parabens")}
              </h1>
              <span className="titulo">Temos mais um benefício para você!</span>
              <span>
                {t(
                  "pages.CampanhasEspeciais.HenriqueJuliano.adiantamentoEstimado"
                )}
              </span>
              <p className="valor linha-paragrafo">
                <b>
                  {signByCurrency(userArtist?.cashAdvanceEstimated?.currency)}
                </b>
                {formatNoSignObject(userArtist?.cashAdvanceEstimated)}
              </p>
              <span
                className="divider"
                style={{
                  backgroundColor: "rgba(156, 154, 255, 1)",
                  opacity: 0.5,
                }}
              />
            </div>
            <div
              style={{
                background:
                  "linear-gradient(rgba(25, 25, 25, 0) 0%, rgb(90, 87, 255) 100%)",
                paddingTop: 12,
              }}
            >
              <ul>
                <li className="circle-checkmark azul">
                  {t(
                    "pages.CampanhasEspeciais.KamillaFialho.kamillaFialhoBeneficio1"
                  )}
                </li>
                <li className="circle-checkmark azul">
                  {t(
                    "pages.CampanhasEspeciais.KamillaFialho.kamillaFialhoBeneficio2"
                  )}
                </li>
                <li className="circle-checkmark azul">
                  {t(
                    "pages.CampanhasEspeciais.KamillaFialho.kamillaFialhoBeneficio3"
                  )}
                </li>
              </ul>
              <div
                className="buttons"
                style={{
                  gap: "15px",
                }}
              >
                <button className="botao-branco" onClick={acceptWithAdvance}>
                  {t("pages.CampanhasEspeciais.queroSolicitar")}
                </button>
                <button className="botao-link" onClick={acceptWithoutAdvance}>
                  {t("pages.CampanhasEspeciais.continuarSemAdiantamento")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default ModalCampaignKFEligible;
